<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
import { GetLogoutUrl } from '../stores/SettingsStore.ts'
import { Button as KButton } from '@progress/kendo-vue-buttons'
import { useLogger } from 'vue-logger-plugin'
import { useCookies } from 'vue3-cookies'
import { onMounted, ref } from 'vue'

// variant="nav-link" renders a plain <a class="nav-link"> so the button matches the other
// items in a Bootstrap dropdown menu (header account menus). Default is the Kendo button.
const props = defineProps<{
  variant?: string
}>()

const logger = useLogger()
const { cookies } = useCookies()
const logoutHref = ref('#')

onMounted(async () => {
  if (props.variant === 'nav-link') {
    logoutHref.value = (await GetLogoutUrl()) || '#'
  }
})

async function logoutClickedHandler() {
  logger.debug('logoutClickedHandler')

  // Only remove the cookie, not the localStorage data
  // This allows the cart to persist for this user when they log back in
  cookies.remove('AoeCartIdToken')

  window.location.href = await GetLogoutUrl()
}
</script>
<template>
  <a
    v-if="props.variant === 'nav-link'"
    class="nav-link"
    :href="logoutHref"
    @click.prevent="logoutClickedHandler"
    >{{ t('labels.Logout') }}</a
  >
  <div v-else class="aoe-logout-button">
    <KButton :fill-mode="'clear'" @click="logoutClickedHandler">{{ t('labels.Logout') }}</KButton>
  </div>
</template>
